import Vue from 'vue'
import Router from 'vue-router'
import config from '@/config'
import Billing from './billing'
import Personal from './personal'
import Single from './single'

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/billing',
  },
  ...Single,
]

export default new Router({
  mode: config.router.mode,

  routes: [...routes, Billing, Personal],
})
